






import Vue from "vue";
import { Component } from "vue-property-decorator";
import SurveyLayout from "@/layouts/SurveyLayout.vue";
import EditorLayout from "@/layouts/EditorLayout.vue";

@Component({
  name: "App",
  components: {
    EditorLayout,
    SurveyLayout
  }
})
export default class App extends Vue {
  layout() {
    // router.jsのroutesにmeta.layoutの存在確認
    // セットするレイアウトを判断する
    return this.$route.meta.layout
      ? this.$route.meta.layout + "-layout"
      : "survey-layout";
  }
}
